/**
 * Application routes constants
 */

const ROUTES = {
  // Main routes
  HOME: '/',
  ABOUT: '/about',
  PRODUCTS: '/products',
  SERVICES: '/services',
  SOLUTIONS: '/solutions',
  INDUSTRIES: '/industries',
  BLOG: '/blog',
  CASE_STUDIES: '/case-studies',
  CAREERS: '/careers',
  SUPPORT: '/support',
  CONTACT: '/contact',
  
  // Auth routes
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  
  // Product routes
  CNC_SYSTEMS: '/products/cnc-systems',
  INDUSTRIAL_ROBOTS: '/products/industrial-robots',
  MEASURING_SYSTEMS: '/products/measuring-systems',
  SMART_FACTORY: '/products/smart-factory',
  
  // Service routes
  SERVICES_CNC: '/services/cnc-systems',
  SERVICES_ROBOTS: '/services/robots',
  SERVICES_IOT: '/services/iot',
  SERVICES_MEASURING: '/services/measuring',
  CNC_DIAGNOSIS_REPAIR: '/services/cnc-diagnosis-repair',
  ROBOT_INTEGRATION: '/services/robot-integration',
  RETROFIT_UPGRADE: '/services/retrofit-upgrade',
  PREVENTIVE_MAINTENANCE: '/services/preventive-maintenance',
  IOT_SYSTEM_MONITORING: '/services/iot-system-monitoring',
  MEASURING_CALIBRATION: '/services/measuring-calibration',
  
  // Solution routes
  CNC_IOT_SOLUTION: '/solutions/cnc-iot',
  ROBOT_AUTOMATION_SOLUTION: '/solutions/robot-automation',
  MEASURING_CALIBRATION_SOLUTION: '/solutions/measuring-calibration',
  ERP_SMART_FACTORY_SOLUTION: '/solutions/erp-smart-factory',
  
  // Industry routes
  AUTOMOTIVE_INDUSTRY: '/industries/automotive',
  ELECTRONICS_INDUSTRY: '/industries/electronics',
  PRECISION_MOLD_INDUSTRY: '/industries/precision-mold',
  METAL_FABRICATION_INDUSTRY: '/industries/metal-fabrication',
  PHARMACEUTICAL_INDUSTRY: '/industries/pharmaceutical',
  
  // Public routes
  BLOG_DETAIL: '/blog/:slug',
  CASE_STUDY_DETAIL: '/case-studies/:slug',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  CUSTOMER_PORTAL: '/customer-portal',
  
  // Error routes
  NOT_FOUND: '*'
};

export default ROUTES; 